import { isServerSidePayloadEventsEnabled, processServerSidePayloadEvent } from './index';

if (typeof window !== 'undefined') {
  window.EDM.Venom.isServerSidePayloadEventsEnabled = isServerSidePayloadEventsEnabled;
  window.EDM.Venom.processServerSidePayloadEvent = processServerSidePayloadEvent;
}
